// styled.js
import styled from 'styled-components';
import DatePicker from "react-datepicker"; // 달력 입력란 사용

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;
export const SearchContainer = styled.div`
  width:100%;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    width: 100%;
    max-width: 100%;
    margin: 0;
    overflow-x: hidden;
  }
`;


export const SearchBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`;

export const InputBase = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 12px;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    padding: 12px;
    font-size: 14px;
    border-radius: 8px;
    width: 100%;
    max-width: 100%;
  }
`;

export const SearchInput = styled.input`
  ${InputBase};
`;

export const SearchLabel = styled.label`
  margin-bottom: 5px;
  font-weight: bold;
  font-size:14px;
  text-align:left;
`;

export const SelectBox = styled.select`
  ${InputBase};
`;

export const DateInput = styled(DatePicker)`
  padding: 10px 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 12px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    padding: 12px;
    font-size: 14px;
    border-radius: 8px;
  }
`;
export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  background-color: ${props => props.primary ? '#007bff' : '#6c757d'};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.3s;
  &:hover {
    background-color: ${props => props.primary ? '#0056b3' : '#5a6268'};
  }
  svg {
    margin-right: 5px;
  }
  
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 8px;
    width: 100%;
    margin-top: 8px;
  }
`;